module.exports = __WEBPACK_EXTERNAL_MODULE_75__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/utils/MemUtil"
// module id = 75
// module chunks = 1